import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "./Context/AuthContext";
import { AxiosSetup } from "./utils/helpers/api.helpers";

AxiosSetup();

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(<Provider store={store}> <BrowserRouter> <AuthProvider> <App /> </AuthProvider> </BrowserRouter> </Provider>
);
